<template>
  <div>

    <el-row style="margin-bottom:10px;">
      <el-col :span="18" class='flex'>
        <el-input v-model="getUserVisitorClassList_data.uvcName" placeholder="请输入名称" clearable size='small'
          style="max-width:200px;" />
        <el-button v-click.getUserVisitorClassList type="primary" icon='el-icon-search' size='small'
          style='margin-left:10px;'>搜索
        </el-button>
      </el-col>

    </el-row>

    <mytable :tableColums='tableColums_getUserVisitorClassList' api='getUserVisitorClassList'
      xupdateapi='updateBusinessIntroduce' :height="H-165">

    </mytable>


  </div>
</template>

<script>
  export default {
    data() {
      return {
        biId: null,
        theMtId: "",

        tableColums_getUserVisitorClassList: {
          $selection: false,


          uvcName: '拜访名称',


          createtime: '创建时间',



        },

      };
    },

    watch: {

    },

    methods: {},

    created() {
      this.getUserVisitorClassList();

    }
  };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/help/TypeOfVisit.vue